const strings = {
    manageAppsAndSettings: 'Home'
};

export { strings };
//# sourceMappingURL=strings.js.map
